import React from 'react';
import { useQuery } from 'react-query';

import {
  ACTION_ERROR_INTER,
  DATA_INTER,
  MODULE_NAME,
  RAW_INTER,
} from './constant';
import { Component } from './component';
import { action } from './action';
import { convert } from './convert';

export const Container: React.FC<{}> = ({}) => {
  const preFetch = useQuery(MODULE_NAME, action);

  const isLoading = () => {
    if (preFetch.isLoading || preFetch.isFetching) {
      return true;
    }
  };

  const isSuccess = () => {
    if (preFetch.isSuccess && !preFetch.isFetching) {
      return true;
    }
  };

  const isError = () => {
    if (preFetch.isError && !preFetch.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = preFetch.error as ACTION_ERROR_INTER;

    if (error) {
      return error.message;
    }
  };

  const getData = (): DATA_INTER | undefined => {
    const data = preFetch.data as unknown as RAW_INTER;

    if (data) {
      return convert(data);
    }
  };

  return (
    <Component
      data={getData()}
      isLoading={isLoading()}
      isError={isError()}
      isSuccess={isSuccess()}
      errorMessage={getErrorMessage()}
    />
  );
};
